export type SwipeAction = 'pass' | 'like' | 'share';

export function swipePreview(dx: number, dy: number, width: number) {
  const horizontal = Math.abs(dx);
  const vertical = Math.abs(dy);
  const action: SwipeAction | null =
    dy < -3 && vertical > horizontal * 1.15
      ? 'share'
      : horizontal > 3 && horizontal > vertical * 1.15
        ? dx > 0
          ? 'like'
          : 'pass'
        : null;
  const threshold = action === 'share' ? 85 : Math.max(65, Math.min(110, width * 0.22));
  return {
    action,
    progress: action ? Math.min(1, (action === 'share' ? vertical : horizontal) / threshold) : 0,
  };
}

export function swipeAction(dx: number, dy: number, width: number): SwipeAction | null {
  const horizontal = Math.abs(dx);
  const vertical = Math.abs(dy);
  if (dy < -85 && vertical > horizontal * 1.15) return 'share';
  if (horizontal > Math.max(65, Math.min(110, width * 0.22)) && horizontal > vertical * 1.15)
    return dx > 0 ? 'like' : 'pass';
  return null;
}
